<template>
    <div>
        <div class="d-flex align-items-center">
            <pc-button
                v-if="showBegin"
                v-bind:disabled="readonly || envelopeElement_missingRequiredAttachment"
                v-on:click="onCreateEnvelope">
                {{ beginWetSignButton }}
            </pc-button>
            <envelope-completed-badge v-if="envelopeElement_isStatusCompleted" />
            <pc-button
                v-if="envelopeElement_isStatusTerminal"
                v-bind:disabled="readonly"
                v-on:click="onStartOver">
                {{ startOverButton }}
            </pc-button>
            <pc-button
                v-if="showDiscard"
                v-bind:disabled="readonly"
                v-on:click="onDiscardEnvelope">
                {{ discardButton }}
            </pc-button>
            <pc-button
                v-if="showComplete"
                v-bind:disabled="!canComplete || readonly"
                class="ms-2"
                v-on:click="onCompleteEnvelope">
                {{ completeButton }}
            </pc-button>
        </div>
    </div>
</template>
<script>
    import Vuex from "vuex";

    import envelopeCompletedBadge from "./envelopeCompletedBadge.vue";
    import { PROJECT_TYPES } from "SharedStores/Project/projectStore";
    import { ENVELOPE_ITEM_TYPE } from "ESignatures/EditEnvelope/editEnvelopeStore";
    import { envelopeElementMixin } from "./envelopeElementMixin";
    import { getResponsiveClassMap } from "Responsive/manager";

    const responsiveConfig = {
        summaryContainer: {
            col: { xs: 12, md: 6 },
            always: "col ms-3 mb-3"
        }
    };

    export default {
        components: {
            envelopeCompletedBadge
        },
        mixins: [envelopeElementMixin],
        inject: {
            viewport: {
                from: "viewport",
                default: null
            },
            readonly: {
                from: "readonly",
                default: false
            }
        },
        props: {
            envelopeDefinition: { type: Object, required: true },
            envelope: { type: Object, required: false, default: null }
        },
        emits: ["create-wet-sign-envelope", "complete-wet-sign-envelope", "void-envelope", "start-over"],
        data() {
            return {};
        },
        computed: {
            showBegin() {
                return !this.envelopeElement_hasEnvelope;
            },
            showDiscard() {
                return this.envelopeElement_hasEnvelope && !this.envelopeElement_isStatusTerminal;
            },
            showComplete() {
                return this.envelopeElement_hasEnvelope && !this.envelopeElement_isStatusTerminal;
            },
            envelopeItems() {
                if (!this.envelope) {
                    return [];
                }
                return Object.values(this.envelope.Items);
            },
            canComplete() {
                return this.envelopeElement_hasEnvelope && this.envelopeItems.every((ei) => this.isItemComplete(ei));
            },
            responsiveClasses() {
                return getResponsiveClassMap(this.viewport, responsiveConfig);
            },
            ...Vuex.mapGetters({
                attachmentFromId: PROJECT_TYPES.getters.attachmentFromId
            })
        },
        methods: {
            getItemDefinition(item) {
                return this.envelope.Definition.Items[item.DefinitionId];
            },
            onCreateEnvelope() {
                this.$emit("create-wet-sign-envelope");
            },
            onCompleteEnvelope() {
                this.$emit("complete-wet-sign-envelope");
            },
            onDiscardEnvelope() {
                this.$emit("void-envelope");
            },
            onStartOver() {
                this.$emit("start-over");
            },
            isItemComplete(item) {
                const definition = this.getItemDefinition(item);
                switch (definition.Type) {
                    case ENVELOPE_ITEM_TYPE.Attachment:
                        return (
                            !definition.IsRequired || Boolean(this.attachmentFromId(definition.AttachmentDefinitionId))
                        );
                    case ENVELOPE_ITEM_TYPE.ContentItem:
                        return true;
                    case ENVELOPE_ITEM_TYPE.DocumentTemplate:
                        return item.Document != null;
                    default:
                        throw `Unexpected item type ${definition.Type}`;
                }
            }
        }
    };
</script>
